import { Component, Input, OnChanges } from '@angular/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';
import sunburst from 'highcharts/modules/sunburst.js';
import { Indicator } from 'src/app/core/_models/indicator';
import { ProjectEcoPro } from 'src/app/core/_models/projectEcoPro';
import { SolutionEcoPro } from 'src/app/core/_models/solutionEcoPro';
import { Structure } from 'src/app/core/_models/structure';
import { StructureTypeProject } from 'src/app/core/_models/structureTypeProject';
import { HIGHCHARTS_EXPORTING, HIGHCHARTS_TRANSLATIONS } from 'src/constants/graph.constants';
sunburst(Highcharts);
HC_exporting(Highcharts);
HC_offlineExporting(Highcharts);

@Component({
  selector: 'app-sunburst-indicators-byStructureTypes',
  templateUrl: './sunburst-indicators-byStructureTypes.component.html',
  styleUrls: ['./sunburst-indicators-byStructureTypes.component.scss']
})
export class SunburstIndicatorsByStructureTypesComponent implements OnChanges {
  @Input() projectData: ProjectEcoPro = {};
  @Input() indicators: Indicator[] = [];
  structures: Structure[] = [];

  indicatorComparatif: Indicator = {
    isChecked: false,
    displayName: ''
  };

  solutionComparatif: SolutionEcoPro = { structureTypesProject: [] };
  updateFlag: boolean = false;
  totalRef: number = 0;

  // Highcharts config

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    lang: HIGHCHARTS_TRANSLATIONS,
    title: {
      text: "Détail scénario et catégorie d'aménagement"
    },
    exporting: HIGHCHARTS_EXPORTING
  };

  constructor(public labelI18n: LabelI18nService) {}

  ngOnChanges() {
    let solutionComparative: SolutionEcoPro | undefined = this.projectData?.solutionsEcoPro?.find((solution: SolutionEcoPro) => solution.solutionEcoProId == this.solutionComparatif.solutionEcoProId);

    if (this.indicatorComparatif && this.solutionComparatif && solutionComparative != null) this.formatDataForGraph();
    else {
      this.solutionComparatif = { structureTypesProject: [] };
    }
  }

  selectSolutionChange(solutionEcoProId: any) {
    let solutionComparative: SolutionEcoPro | undefined = this.projectData?.solutionsEcoPro?.find((solution: SolutionEcoPro) => solution.solutionEcoProId == solutionEcoProId);
    if (solutionComparative) {
      this.solutionComparatif = solutionComparative;
      if (this.indicatorComparatif && this.solutionComparatif) this.formatDataForGraph();
    }
  }

  selectIndicatorChange(indicatorId: any) {
    let i: Indicator | undefined = this.indicators?.find((indicator: Indicator) => indicator.indicatorId == indicatorId);
    if (i) {
      this.indicatorComparatif = i;
      if (this.indicatorComparatif && this.solutionComparatif) this.formatDataForGraph();
    }
  }

  formatDataForGraph() {
    let dataForGraph: { id: string; parent: string; name: string; value?: number; color?: string | undefined }[] = [];
    let indexLevel_3: number = 0;
    let indexLevel_4: number = 0;

    // Indicateur : LEVEL 1

    if (this.indicatorComparatif) {
      dataForGraph.push({
        id: '0.0',
        parent: '',
        name: this.labelI18n.indicatorLabelWithUnit(this.indicatorComparatif)
      });
    }

    // Catégories d'Infrastructures / Aménagements : LEVEL 2

    this.solutionComparatif.structureTypesProject.forEach((structureTypeProject: StructureTypeProject, indexLevel_2) => {
      dataForGraph.push({
        id: '1.' + indexLevel_2,
        parent: '0.0',
        name: `${structureTypeProject.structureType.displayName}`,
        color: `${structureTypeProject.structureType.color}`
      });

      // Catégorie de structure : LEVEL 3

      let subStructureTypes: any[] = [];

      if (structureTypeProject.structures) {
        structureTypeProject.structures.forEach((structure) => {
          let subStructureType = subStructureTypes.find((substructure) => substructure.substructureTypeId == structure.substructureTypeId);

          if (subStructureType == null) {
            subStructureType = { index: indexLevel_3, displayName: structure.substructureTypeDisplayName, substructureTypeId: structure.substructureTypeId, structures: [structure] };
            subStructureTypes.push(subStructureType);

            dataForGraph.push({
              id: '2.' + subStructureType.index,
              parent: '1.' + indexLevel_2,
              name: `${structure.substructureTypeDisplayName}`
            });

            indexLevel_3++;
          } else {
            subStructureType.structures?.push(structure);
          }

          // Opérations : LEVEL 4

          structure.structureOperations?.forEach((operation) => {
            const ceuValueForOperation = +operation.impactsCEU?.find((impact) => impact.displayName == this.indicatorComparatif.displayName)?.value!;
            const structureQuantity = structure.quantity ? structure.quantity : 0;

            dataForGraph.push({
              id: '3.' + indexLevel_4,
              parent: '2.' + subStructureType.index,
              name: `${operation.displayName}`,
              value: Number((ceuValueForOperation * structureQuantity).toFixed(2))
            });

            indexLevel_4++;
          });
        });
      }
    });

    this.chartOptions.series = [
      {
        type: 'sunburst',
        data: dataForGraph,
        tooltip: {
          valueDecimals: 2
        },
        cursor: 'pointer',
        dataLabels: {
          format: '{point.name}',
          filter: {
            property: 'innerArcLength',
            operator: '>',
            value: 16
          },
          rotationMode: 'circular'
        },
        levels: [
          {
            level: 1,
            color: 'white',
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: 'outerArcLength',
                operator: '>',
                value: 64
              }
            }
          },
          {
            level: 2,
            colorByPoint: true
          } as any,
          {
            level: 3
          },
          {
            level: 4,
            dataLabels: {
              format: '{point.name}<br/>{point.value}'
            }
          }
        ]
      }
    ];
    this.updateFlag = true;
  }
}
